import { UntypedFormGroup } from '@angular/forms';

import { AppNotifications } from '../consts/app-notifications';
import { thresholdOptions } from '../dialogs/profile/profile.component';
import { IProfile } from '../interfaces/profile';

export class ProfileModel {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  notifications: string[] = [];
  enableLowPriceThreshold: boolean;
  lowPriceThreshold: number;

  populateFromFormGroup(formGroup: UntypedFormGroup): void {
    this.firstName = this.removeExtraSpaces(formGroup.get('firstName')?.value);
    this.lastName = this.removeExtraSpaces(formGroup.get('lastName')?.value);
    this.email = formGroup.get('email')?.value;
    this.password = formGroup.get('password')?.value;

    const thresholdValue = formGroup.get('lowPriceThreshold')?.value;
    this.lowPriceThreshold = thresholdValue;
    this.enableLowPriceThreshold = Boolean(thresholdValue);

    if (formGroup.get('cbIndividualSale')?.value) {
      this.notifications.push(AppNotifications.emailInventorySale);
    }

    if (formGroup.get('cbInventoryAdded')?.value) {
      this.notifications.push(AppNotifications.emailInventoryPurchase);
    }

    if (formGroup.get('cbPaymentComplete')?.value) {
      this.notifications.push(AppNotifications.emailPaymentComplete);
    }

    if (formGroup.get('cbDailySummary')?.value) {
      this.notifications.push(AppNotifications.emailDailySummary);
    }

    if (formGroup.get('cbWeeklySummary')?.value) {
      this.notifications.push(AppNotifications.emailWeeklySportsReport);
    }
  }

  populateFromInterface(dto: IProfile): void {
    this.firstName = dto.firstName;
    this.lastName = dto.lastName;
    this.email = dto.email;
    this.enableLowPriceThreshold = dto.enableLowPriceThreshold;
    this.lowPriceThreshold = dto.lowPriceThreshold;

    if (dto.notifications) {
      this.notifications = [...dto.notifications];
    }
  }

  private removeExtraSpaces(value: string | null): string | null {
    if (!value) {
      return null;
    }
    return value.trim().replace(/\s\s+/g, ' ');
  }
}
